/** @jsxImportSource @emotion/react */
import { useRouterStore } from 'mobx-state-router';
import React, { useEffect, useState } from 'react';

import { Select } from 'src/common/ui/components';
import { ENROLLMENT_STATUS_OPTIONS } from 'src/components/forms/schemas/definitions';

type EnrollmentOption = {
  label: string;
  value: keyof typeof ENROLLMENT_STATUS_OPTIONS;
};

const enrollmentOptions: EnrollmentOption[] = Object.keys(ENROLLMENT_STATUS_OPTIONS).map(key => ({
  label: ENROLLMENT_STATUS_OPTIONS[key] as string,
  value: key as keyof typeof ENROLLMENT_STATUS_OPTIONS,
}));

export const FilterEnrollmentStatus = ({
  onChange,
}: {
  onChange: (option: EnrollmentOption | null) => void;
}) => {
  const routerStore = useRouterStore();

  // Filter: Enrollment status
  const initialEnrollmentStatus =
    enrollmentOptions.find(
      ({ value }) => value === routerStore.routerState.queryParams.enrollmentStatus,
    ) || null;
  const [enrollmentStatus, setEnrollmentStatus] = useState<EnrollmentOption | null>(
    initialEnrollmentStatus,
  );

  useEffect(() => {
    const filters: Record<string, string | undefined> = {};
    filters.enrollmentStatus = enrollmentStatus === null ? undefined : enrollmentStatus?.value;

    routerStore.setRouterState({
      ...routerStore.routerState,
      queryParams: {
        ...routerStore.routerState.queryParams,
        ...filters,
      },
    });
  }, [routerStore, enrollmentStatus]);

  useEffect(() => {
    onChange(enrollmentStatus);
  }, [onChange, enrollmentStatus]);

  return (
    <Select
      id="enrollmentStatus"
      label="Enrollment Status"
      options={enrollmentOptions}
      onChange={(event, value) => setEnrollmentStatus(value)}
      value={enrollmentStatus}
    />
  );
};
